import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { fuseAnimations } from '../../../@fuse/animations';
import { modules } from '../../shared/order.module';

@Component({
  selector: 'terms',
  templateUrl: 'terms.html',
  styleUrls: ['./terms.component.css'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone:true,
  imports:[modules]
})
export class TermsPolicyDialog implements OnInit {
  subdomain = '';
  constructor(
    public dialogRef: MatDialogRef<TermsPolicyDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    console.log('Dialog data ===> ', data);
    //his.html5QrCode ;
    const { hostname } = new URL(window.location.href);
    let subdomain = hostname;
    this.subdomain = subdomain;
  }

  ngOnInit(): void {}

  close(): void {
    this.dialogRef.close();
  }
}
